/**
 * 
 * Input Box
 * 
 */

import React from 'react';
import { InputText } from 'primereact/inputtext';
import moment from 'moment';

class InputBox extends React.Component {

    render() {
        const { name, label, value, placeholder, fieldStatus, onInputChange, defaultValue, disabled } = this.props;
        const display = fieldStatus && fieldStatus === "Display Only";
        
        return (<div className="p-col-12">
            {!display ? <label className="label">
                {label}
                {/* <span className="requiredColor">*</span> */}
            </label> : null}
            <div className={display ? "mt3": "mt1"}>
                {display ?
                    <div>  {`${label}: ${typeof value === 'number' ? value : isNaN(Date.parse(value)) ? value :  moment(value).format('MM/DD/YYYY')}`}</div> :
                    <InputText
                        className="p-col-12"
                        value={value && label === 'Date' && !isNaN(Date.parse(value)) ? moment(value).format('MM/DD/YYYY') : value }
                        name={name}
                        disabled={disabled}
                        onChange={onInputChange}
                        placeholder={placeholder} />}
            </div>
        </div>)
    }
}


export default InputBox;